export default [{
  name: 'downloads.skywire.minerAssemblyManualHiRes',
  download: 'https://downloads.skycoin.com/skywire/Skywire_Miner_Assembly_Manual_v2.3_Hi-Res.pdf',
  filetype: '.pdf',
  filesize: '29.9mb',
},
{
  name: 'downloads.skywire.minerAssemblyManual',
  download: 'https://downloads.skycoin.com/skywire/Skywire_Miner_Assembly_Manual_v2.3.pdf',
  filetype: '.pdf',
  filesize: '4.3mb',
},
{
  name: 'downloads.skywire.skyminer',
  download: 'https://downloads.skycoin.com/skywire/Skyminer-v2.2_zh.pdf',
  filetype: '.pdf',
  filesize: '7mb',
},
];



// WEBPACK FOOTER //
// ./src/components/Downloads/components/Skywire/content.js